module.exports = __webpack_public_path__ + "img/Counting02-min.aa509e14.png";